import { put, select, takeLatest } from 'redux-saga/effects'
import { getInsuranceInformationStateSelector } from '../selectors'
import { IInsuranceInformationState } from '../store/insuranceInformation.types'
import { InsuranceInformationConstants } from '../store/insuranceInformation.constants'
import { clearInsuranceInformationData, setInsuranceInformationList } from '../store/insuranceInformation.actions'
import { randomNumber } from '../../../utilities'

export function* addInsuranceInformation() {
  const insuranceInformation: IInsuranceInformationState = yield select(getInsuranceInformationStateSelector)
  const { insuranceInformationData, insuranceInformationList } = insuranceInformation
  const { insuranceCarrier, key } = insuranceInformationData
  if (insuranceCarrier && insuranceCarrier.trim()) {
    const updatedInsuranceList = [...insuranceInformationList]
    const selectedInsuranceIndex = updatedInsuranceList.findIndex((insuranceInfo) => insuranceInfo.key === key)
    if (selectedInsuranceIndex >= 0) {
      updatedInsuranceList[selectedInsuranceIndex] = insuranceInformationData
    } else {
      updatedInsuranceList.push({ ...insuranceInformationData, key: randomNumber().toString() })
    }
    yield put(setInsuranceInformationList(updatedInsuranceList))
    yield put(clearInsuranceInformationData())
  }
}

export function* addInsuranceInformationSaga() {
  yield takeLatest([InsuranceInformationConstants.ADD_INSURANCE_INFORMATION], addInsuranceInformation)
}
